import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { fadeAnimation } from '../../animations/animations';
import { PdvService } from '../../services/pdv/pdv.service';
import { OrdersService } from '../../services/order/orders.service';
import { FamilyService } from '../../services/family/family.service';
import { Component, ViewChild, ElementRef, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { isPlatformBrowser } from '@angular/common';
@Component({
    moduleId: module.id,
    selector: 'carte',
    templateUrl: 'carte.component.html',
    styleUrls: ['carte.component.scss'],
    animations: [fadeAnimation]
})
export class CarteComponent {
    @ViewChild('carte') carte: ElementRef;
    @ViewChild('template') template: ElementRef;
    options: any;
    compositions: any[] = [];
    itemsCompositions: any[] = [];
    selectedCompForSearch: any[] = [];
    searchElement: String = "";
    families: any[] = [];
    menucategories: any[] = [];
    activeTab = 1;
    products: any[] = [];
    menus: any[] = [];
    familyActive = -2;
    menuCategoryActive = -2;
    idPdv: string;
    close: boolean = false;
    subscriptions: Subscription[] = [];
    bsModalRef: BsModalRef;
    modalRef: BsModalRef;
    nbrOffersAuthorizedSite: number;
    offerNbr: number;
    subscriptions2: Subscription[] = [];
    selectedComp = [];
    siteClose: boolean = false;
    @ViewChild('scrollTap') scrollTap: ElementRef
    @ViewChild('scrollTap2') scrollTap2: ElementRef
    displayBestOffers = false;
    displayBestSales = false;
    elementsNbr: number = 0;
    animation: boolean = false;
    siteCloseComment = "";
    discount: number = 0;
    discountFrom: number = 0;
    ourApp = false;
    orderProg;
    alertclose=false;
    hidetopnav=false;
    prevScrollpos =0;
    constructor(
        private familyService: FamilyService,
        private orderService: OrdersService,
        private pdvService: PdvService,
        private modalService: BsModalService,
        public router: Router,
        private route: ActivatedRoute,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {
        this.pdvService.getPdvInfo().subscribe(
            (pdv: any) => {
                if (pdv) {
                    this.displayBestSales = pdv.displayBestSales;
                    this.displayBestOffers = pdv.displayBestOffers;
                }
            }
        )
        const subs = this.orderService.elementsNbr.subscribe(elementsNbr => {
            setTimeout(() => {
                if (elementsNbr > this.elementsNbr) {
                    this.animation = true;
                    this.elementsNbr = elementsNbr;
                }
                setTimeout(() => {
                    this.animation = false;
                }, 500)
            }, 500)
        });
        const subs1=this.pdvService.pdv.subscribe(
            (data) => {
                this.siteClose = data.closeSite;
                this.siteCloseComment = data.closeComment;
                this.discount = data.discount;
                this.discountFrom = data.discountFrom;
            }
        )
        
        const subs2=this.orderService.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )
        const subs3 = this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        this.subscriptions2.push(subs,subs1,subs2,subs3);
        this.getFamiliesOfCarte();
        this.getMenuCategoriesOfCarte();
        this.getCompositionsOfCarte();
    }
    toBasket() {
        if (this.elementsNbr > 0) this.router.navigate(['/checkout']);
    }
    openModal(template: ElementRef) {
        this.subscriptions.push(
            this.modalService.onHidden.subscribe(() => {
                this.unsubscribe();
            })
        );
        this.modalRef = this.modalService.show(template, { class: 'filter-modal' });
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    ngOnInit() {
        setTimeout(
            () => {
                this.setActiveTAb();
            }, 500
        )
        let sub = this.router.events.subscribe((val) => {
            if (val instanceof NavigationEnd) {
                setTimeout(
                    () => {
                        this.setActiveTAb();
                    }, 100
                )
            }
        })
        this.subscriptions2.push(sub);
    }

    setActiveTAb() {
        if (isPlatformBrowser(this.platformId) && this.scrollTap2 && this.scrollTap) {
            var outerContent = (this.router.url.indexOf('menus') > -1) ? this.scrollTap2.nativeElement : this.scrollTap.nativeElement;
            var innerContent = <HTMLElement>document.getElementsByClassName('activeTab')[0];
            if (innerContent) {
                const pos = (outerContent.offsetWidth - innerContent.offsetWidth) / 2;
                outerContent.scroll({ left: this.absoluteOffset(innerContent) - pos, top: 0, behavior: 'smooth' });
            }
        }
    }

    // @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    //     if (isPlatformBrowser(this.platformId)) {
    //         var outerContent = (this.router.url.indexOf('menus') > -1) ? this.scrollTap2.nativeElement : this.scrollTap.nativeElement;
    //         if (window.pageYOffset > 0) {
    //             outerContent.classList.add('steakyTab')
    //         } else {
    //             outerContent.classList.remove('steakyTab')
    //         }
    //     }
    // }

    @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
        if (isPlatformBrowser(this.platformId)) {
            var currentScrollPos = window.pageYOffset;
            var outerContent = (this.router.url.indexOf('menus') > -1) ? this.scrollTap2.nativeElement : this.scrollTap.nativeElement;
            if (this.prevScrollpos < currentScrollPos) {
                this.hidetopnav=true;
                outerContent.classList.add('steakyTab')
            } else {
                this.hidetopnav=false;
                outerContent.classList.remove('steakyTab')
            }
            this.prevScrollpos = currentScrollPos;
        }
    }

    getFamiliesOfCarte() {
        this.familyService.families.subscribe(
            (families: any[]) => {
                this.families = families.map(m => {
                    m.label = m.label.toLowerCase();
                    return m
                })
            }
        )
    }

    getMenuCategoriesOfCarte() {
        this.familyService.menucategories.subscribe(
            (menucategories: any[]) => {
                this.menucategories = menucategories.map(m => { m.name = m.name.toLowerCase(); return m });
            }
        )
    }

    absoluteOffset(elem) {
        return elem.offsetParent && elem.offsetLeft + this.absoluteOffset(elem.offsetParent);
    }

    getCompositionsOfCarte() {
        this.pdvService.getCompositionsOfCarte().subscribe(
            (compositions: any[]) => {
                this.compositions = compositions;
                this.itemsCompositions = compositions;
            }
        )
    }

    search() {
        this.selectedComp = this.compositions.filter(opt => opt.checked).map(opt => opt.id.toString());
        if (this.selectedComp.length > 0) {
            this.orderService.selectedComp.next(this.selectedComp);
            this.getCompositionsOfCarte();
            this.modalRef.hide();
            this.router.navigate(['carte/filter']);
        }
    }
    filterComp(value) {
        if (!value) this.assignComp();
        this.compositions = Object.assign([], this.itemsCompositions).filter(
            c => c.text.toLowerCase().indexOf(value.toLowerCase()) > -1
        )
    }
    assignComp() {
        this.compositions = Object.assign([], this.itemsCompositions);
    }
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }

}